import React, { Fragment, useEffect, useRef, useState } from "react";
import * as ReactDOM from "react-dom";
import { Badge, Card, CardBody, Col, FormGroup, Input, Label } from "reactstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import * as ReactDOMServer from "react-dom/server";
import JqxTable from "../../../../share-components/table/JqxTable";
import InfiniteScroll from "react-infinite-scroll-component";

/* eslint-disable jsx-a11y/anchor-is-valid */
const PartnerProductsJqx = (props) => {
  const {
    setValue,
    trigger,
    watch,
    getValues,
    partnerProducts,
    setButtonDisable,
    isDelete,
    infiniteScrollRef,
    fetchProductData,
    partnerPromotionState,
    selectedIds,
    onSelectionChange,
  } = props;
  let gridRef = useRef(null);
  let selectRef = useRef(null);
  const [products, setProducts] = useState([]);
  const [selectedForDelete, setSelectedForDelete] = useState([]);

  const ourPercentage = watch("percentage");

  //Pagination Calculation
  const pagination = partnerPromotionState?.productsTable?.pagination || {};
  const totalPages = pagination.count ?? 0;
  const totalProducts = pagination.total_products ?? 0;
  const totalItems = pagination.total_items ?? 0;
  const currentPage = pagination.next_page ? pagination.next_page - 1 : 1;
  const perPage = 10;
  const currentPageCount = pagination.page_total ?? 0;

  // Showing range
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * perPage + 1;
  const endItem = totalItems === 0 ? 0 : Math.min((currentPage - 1) * perPage + currentPageCount, totalItems);

  useEffect(() => {
    if (partnerProducts && partnerProducts.length > 0) {
      setProducts((prev) => {
        if (partnerProducts.length > prev.length) {
          return partnerProducts;
        } else {
          return partnerProducts;
        }
      });
    }
  }, [partnerProducts]);

  const onDelete = (index) => {
    const newProducts = [...products];
    newProducts.splice(index, 1);
    setProducts(newProducts);
    setDataToHookForm(newProducts);
  };

  const setDataToHookForm = (data) => {
    setValue("promotion_products_new", data);
    trigger("promotion_products_new");

    setValue("promotion_products", data);
    trigger("promotion_products");
  };

  const calculatePriceAfterDiscount = (discount = 0, itemPrice, salePrice) => {
    let price = itemPrice === null ? salePrice : itemPrice;
    return +(price * (1 - discount / 100)).toFixed(2);
  };

  const isSelected = (item) => selectedIds.includes(item.id);

  const onSelectRow = (item, checked) => {
    const id = item.id;

    onSelectionChange((prev) => {
      if (checked) {
        return [...prev, id];
      }
      return prev.filter((x) => x !== id);
    });
  };

  return (
    <Fragment>
      <div style={{ width: "100%" }}>
        <InfiniteScroll
          ref={(scroll) => {
            infiniteScrollRef.current = scroll;
          }}
          dataLength={products.length}
          next={fetchProductData}
          hasMore={partnerPromotionState.promotions_products.pagination.has_more}
          refreshFunction={() => {
            alert("Test");
          }}
          pullDownToRefresh={true}
          // onScroll={(e)=>{console.log(e)}}
          height={400}
          loader={<p>Loading...</p>}
        >
          <table
            className="table"
            style={{
              width: "100%",
              // height: 500,
              // overflowY: "scroll",
              display: "block",
              borderCollapse: "collapse",
              border: "1px solid #dee2e6",
            }}
          >
            <thead>
              <tr style={{ display: "table", width: "100%", tableLayout: "fixed", border: "1px solid #dee2e6" }}>
                <th style={{ width: "5%", border: "1px solid #dee2e6" }}></th>
                <th style={{ width: "40%", border: "1px solid #dee2e6" }}>Product</th>
                <th style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>Stock</th>
                <th style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>Sale Price</th>
                <th style={{ width: "10%", textAlign: "center", border: "1px solid #dee2e6" }}>RRP</th>
                <th style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>Price After Discount</th>
              </tr>
            </thead>
            <tbody
              style={{
                display: "block",
                // maxHeight: "340px",
                // overflowY: "auto"
              }}
            >
              {products.map((item, i) => (
                <tr key={i} style={{ display: "table", width: "100%", tableLayout: "fixed", border: "1px solid #dee2e6" }}>
                  <td
                    style={{
                      width: "5%",
                      position: "relative",
                    }}
                  >
                    <input
                      type="checkbox"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                      checked={isSelected(item)}
                      onChange={(e) => onSelectRow(item, e.target.checked)}
                    />
                  </td>
                  <td style={{ width: "40%" }}>
                    <div className="row" style={{ padding: 5 }}>
                      <div className="col-md-4">
                        <img className="img-fluid" src={item.image || "https://via.placeholder.com/50"} width="50" alt="" />
                      </div>
                      <div className="col-md-8">
                        <p className="font-primary mb-0">{item.name}</p>
                        <p className="mb-0">{item.colour ? `${item.colour} - ${item.size}` : `${item.size}`}</p>
                        <p className="mb-0">{item.sku}</p>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>{item.current_stock || 0}</td>
                  <td style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>{Number(item.sale_price ?? 0).toFixed(2)}</td>
                  <td style={{ width: "10%", textAlign: "center", border: "1px solid #dee2e6" }}>{Number(item.price ?? 0).toFixed(2)}</td>
                  <td style={{ width: "15%", textAlign: "center", border: "1px solid #dee2e6" }}>
                    {calculatePriceAfterDiscount(ourPercentage, item.price, item.price).toFixed(2)}
                  </td>
                  {/* <td style={{ width: "5%", border: "1px solid #dee2e6", fontSize: "1rem" }}>
                    <a style={{ color: "red" }} onClick={() => onDelete(i)}>
                      <span className="fa fa-trash"></span>
                    </a>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
      <div style={{ marginTop: 40 , marginLeft : 20 , marginRight : 20}}>
        <div className="d-flex justify-content-end align-items-center">
          <div>
            <strong>Total Products:</strong> {totalProducts}
          </div>
          <div className="ml-4">
            <strong>Total Items:</strong> {totalItems}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PartnerProductsJqx;
